import {ApiClient} from "../utils/apiClient";

export const deleteItem = async (baseUrl, id) => {
    await ApiClient.delete(`${baseUrl}/${id}`);
}
